import ClientDetail from './ClientDetail';
import ClientList from './ClientList';
import ClientNew from './ClientNew';
import Status from './Status';

export default {
  ClientDetail,
  ClientList,
  ClientNew,
  Status,
};
